var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_c('router-link',{attrs:{"to":"/m/login"}},[_vm._v("Log In")]),_vm._v(" or "),_c('router-link',{attrs:{"to":"/m/register"}},[_vm._v("Sign Up")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }